module.exports = __webpack_public_path__ + "static/media/vkdonut_donuts_3x.4c9e11bc.png";